import { render, staticRenderFns } from "./ViewAdSpaceScreenSaver.vue?vue&type=template&id=633d32ea&scoped=true&"
import script from "./ViewAdSpaceScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ViewAdSpaceScreenSaver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d32ea",
  null
  
)

export default component.exports